let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8k3IU")).then(() => parcelRequire('hxssF'));